import fetch from "../../auth/FetchInterceptor";

export const getCustomers = function (data) {
  data = {
    ...data,
    fields: "name,phone,email"
  }
  return fetch({
    url: '/v1/customers',
    method: 'get',
    params: data
  })
}

export const createCustomer = function (data) {
  return fetch({
    url: '/customers',
    method: 'post',
    data: data
  })
}

export const getCustomer = function (id) {
  return fetch({
    url: `customers/${id}`,
    method: 'get'
  })
}

export const getCarByPlate = function (plate, state) {
	return fetch({
		url: `cars/by_plate/${state}/${plate}`,
		method: 'GET',
	});
};

export const updateCustomer = function (id, data) {
  return fetch({
    url: `/customers/${id}`,
    method: 'put',
    data: data
  })
}

export const deleteCustomer = function (id) {
  return fetch({
    url: `/customers/${id}`,
    method: 'delete'
  })
}